import Cookies from 'js-cookie';

/* eslint-disable no-underscore-dangle */
global.dataLayer = global.dataLayer || [];

/**
 * Send an event to GTM with relevant event data
 * @param {String} category
 * @param {String} label
 * @param {String} action
 * @param {Object} extraData
 */
const trackAction = (category, label, action, extraData = {}) => {
  const trackingData = {
    event: 'custom-event', // Use 'custom-event' string to make tracking.js applicable to other projects as well.
    category,
    label,
    action,
    ...extraData,
  };

  if (process.env.NODE_ENV !== 'production') {
    /* eslint-disable no-console */
    console.info('sending data to GTM:');
    console.table(trackingData);
    /* eslint-enable no-console */
  }

  global.dataLayer.push(trackingData);
};

const trackSqzlPageView = () => {
  if (typeof window !== 'undefined') {
    if (window._sqzl) {
      window._sqzl.push({ event: 'PageView' });
    }
  }
};

const setSqzlCookieConsent = () => {
  const { sfnAcceptAnalytics, sfnAcceptThirdParty } = Cookies.get('');
  const permission = [];
  if (sfnAcceptAnalytics) {
    permission.push('analytics');
  }
  if (sfnAcceptThirdParty) {
    permission.push('marketing');
  }
  if (typeof window !== 'undefined') {
    if (window._sqzl) {
      window._sqzl.push({
        consent: `${sfnAcceptThirdParty || sfnAcceptAnalytics ? 'grant' : 'revoke'}`,
        permissions: permission,
      });
    }
  }
  trackSqzlPageView();
};
export default trackAction;
export { setSqzlCookieConsent };
